module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.9b2816a1.mp3";